<template>
  <div>
    <div class="bg-white shadow-sm rounded-md h-60 overflow-x-auto">
      <div class="border-b-0.5 flex justify-between items-center">
        <p class="p-2 text-sm">Announcement</p>
        <router-link
          v-tooltip="'You have new messages.'"
          :to="{ name: 'announcements' }"
        >
          <img class="h-4 cursor-pointer pr-2" src="@/assets/icons/add.png" />
        </router-link>
      </div>
      <div class="flex flex-col gap-y-1 p-2" v-if="items.length">
        <div
          :class="open == index ? 'border-1.5 rounded-md' : 'border-none'"
          v-for="(item, index) in items"
          :key="index"
        >
          <div
            :class="open == index ? 'border-none' : 'border-1.5 rounded-md'"
            @click="view(index)"
            class="flex justify-between items-center border-1.5 p-2 rounded-md cursor-pointer"
          >
            <p class="text-sm">{{ item.Title }}</p>
            <img
              class="h-4"
              :class="
                open == index ? '-rotate-0 transform' : '-rotate-90 transform'
              "
              src="@/assets/icons/caret.png"
            />
          </div>
          <transition name="accordion">
            <p
              v-if="open == index"
              class="px-1.5 p-2"
              style="font-size: 0.8rem !important"
            >
              {{ item.Content }}
            </p>
          </transition>
        </div>
      </div>

      <div class="max-h-screen px-4" v-else>
        <div
          v-if="!loading || items.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Announcement",
  data() {
    return {
      open: null,
      items: [],
    };
  },
  created() {
    this.getAnnouncements();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    view(index) {
      if (index == this.open) {
        this.open = null;
      } else {
        this.open = index;
      }
    },
    // /{organization}/announcement/upcomming/v1/request
    getAnnouncements() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/announcement/upcomming/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.items = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
